/**
 * The total the /checkout page shows next to Pay, given the per-line figure it
 * composed and the amount the server last answered for the payment.
 *
 * The server charges the client's figure only when it reconciles exactly at
 * the client's rate; otherwise (a rate older than the server's, a cached page
 * with stale catalog prices) it charges its own per-line figure and returns it
 * as `amount_cents`. The money-display rule is that the shown total is the
 * charged one, and a mismatch is fixed on the DISPLAY side, never the charge.
 */

export interface ServerCharge {
  cents: number;
  currency: string;
}

export function shownTotalCents(composed: number, server: ServerCharge | null, chargeCurrency: string): number {
  if (!server || server.cents <= 0) return composed;
  if (server.currency.toLowerCase() !== chargeCurrency.toLowerCase()) return composed;
  return server.cents;
}

/** True when the shown total is the server's figure rather than the lines' sum. */
export function totalFollowsServer(composed: number, server: ServerCharge | null, chargeCurrency: string): boolean {
  return shownTotalCents(composed, server, chargeCurrency) !== composed;
}
